import React from "react";
import Dashboard from "./Dashboard";

const CertfocusDashboard = ({ dashboardId, sessionToken }) => {
  return <Dashboard dashboardId={dashboardId} sessionToken={sessionToken} title="Certfocus Dashboard" />;
};

export default CertfocusDashboard;
